export default __webpack_public_path__ + "static/media/background.b06332ea.png";